var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.778l3.773-3.107a.75.75 0 11.954 1.158l-4.25 3.5a.75.75 0 01-.954 0l-4.25-3.5a.75.75 0 01.954-1.158z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTYgMTIiIHdpZHRoPSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNy45OTk5OSA2Ljc3ODQxIDMuNzczMjEtMy4xMDczNmMuMzE5OC0uMjYzMzIuNzkyNC0uMjE3NTcgMS4wNTU3LjEwMjE3LjI2MzQuMzE5NzQuMjE3Ni43OTI0MS0uMTAyMSAxLjA1NTczbC00LjI1MDAzIDMuNWMtLjI3Njk0LjIyODA3LS42NzY2Mi4yMjgwNy0uOTUzNTYgMGwtNC4yNS0zLjVjLS4zMTk3NC0uMjYzMzItLjM2NTQ5LS43MzU5OS0uMTAyMTctMS4wNTU3M3MuNzM1OTktLjM2NTQ5IDEuMDU1NzMtLjEwMjE3eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { SvgDropdownOutline16 as ReactComponent };